import moment from 'moment';

function dateParser(date) {
  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate.format('D/MM/YYYY h:mm a') : null;
}
export default dateParser;
